import React from 'react';
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import { Separator } from '@/components/ui/separator';
import { Button } from '@/components/ui/button';
import Link from '../../components/atomic/Link';

const PurchaseCard = ({
  dashboardLinkPrefix,
  type = 'userSinglePaymentId',
  date,
  nextBillingDate,
  orderNumber,
  amount,
  cancelled,
  onSubCancel,
  onCancelConfirm,
}) => {
  const cardTitles = {
    userSinglePaymentId: 'Trygt utført',
    userSubscriptionId: 'Boligmappa+',
  };
  const cardDescriptions = {
    userSinglePaymentId: (
      <p>
        Les mer om Trygt utført på{' '}
        <Link
          href="https://support.boligmappa.no/hc/no/sections/15094668733330-Trygt-utf%C3%B8rt"
          openInNewTab
          isExternal
          className="cursor-pointer"
        >
          våre hjelpesider.
        </Link>
      </p>
    ),
    userSubscriptionId: (
      <p>
        Les mer om Boligmappa+ på{' '}
        <Link
          href="https://support.boligmappa.no/hc/no/sections/15195529721746-Boligmappa"
          isExternal
          openInNewTab
          className="cursor-pointer"
        >
          våre hjelpesider.
        </Link>
      </p>
    ),
  };

  return (
    <>
      <Card>
        <CardHeader>
          <CardTitle>{cardTitles[type]}</CardTitle>
          <CardDescription>{cardDescriptions[type]}</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="flex flex-col">
            {type === 'userSubscriptionId' && (
              <>
                <div className="flex justify-between items-center p-4">
                  <p className="font-medium">Status</p>
                  <p>{cancelled ? 'Kansellert' : 'Aktiv'}</p>
                </div>
                <Separator />
              </>
            )}

            <div className="flex justify-between items-center  p-4">
              <p className="font-medium">Dato for kjøp</p>
              <p>{date}</p>
            </div>
            <Separator />

            {type === 'userSinglePaymentId' && (
              <>
                <div className="flex justify-between items-center  p-4">
                  <p className="font-medium">Ordrenummer</p>
                  <p>{orderNumber}</p>
                </div>
                <Separator />
                <div className="flex justify-between items-center  p-4">
                  <p className="font-medium">Beløp</p>
                  <p>{amount} kr</p>
                </div>
                <Separator />
                <div className="flex flex-row flex-wrap items-center  p-4">
                  Forsikringsdokumenter finner du i &nbsp;
                  <Link
                    className="cursor-pointer"
                    to={`${dashboardLinkPrefix}/documents?personal=true`}
                  >
                    Personlig område
                  </Link>
                  . Informasjon om&nbsp;
                  <Link
                    href="https://support.boligmappa.no/hc/no/articles/15474983466386-Hvordan-kansellere-Trygt-utf%C3%B8rt-"
                    isExternal
                    className="cursor-pointer"
                  >
                    angrerett finner du her
                  </Link>
                  .
                </div>
              </>
            )}

            {type === 'userSubscriptionId' && (
              <>
                <div className="flex justify-between items-center  p-4">
                  <p className="font-medium">
                    {cancelled ? 'Utløpsdato' : 'Neste trekk'}
                  </p>
                  <p>{nextBillingDate}</p>
                </div>
              </>
            )}
          </div>
        </CardContent>
        <Separator />
        <CardFooter>
          <div className="flex flex-row w-full justify-end">
            {type === 'userSubscriptionId' && !cancelled && (
              <Dialog>
                <DialogTrigger asChild>
                  <Button
                    className="cursor-pointer"
                    variant="outline"
                    onClick={() => onSubCancel()}
                  >
                    Avslutt abonnement
                  </Button>
                </DialogTrigger>
                <DialogContent className="sm:max-w-md">
                  <DialogHeader>
                    <DialogTitle>Avslutt Boligmappa+?</DialogTitle>
                    <DialogDescription>
                      Dette skjer når du avslutter ditt abonnement:
                    </DialogDescription>
                  </DialogHeader>
                  <div className="flex flex-col items-center text-sm">
                    <ul className="list-disc pl-4 space-y-3">
                      <li>
                        Din bruker mister tilgang til alt innhold fra
                        Boligmappa+ når nåværende, betalte abonnementperiode
                        utløper.
                      </li>
                      <li>
                        Du kan når som helst reaktivere abonnementet til den
                        gjeldende markedsprisen på reaktiveringstidspunktet.
                      </li>
                      <li>
                        Avsluttet abonnement vil ikke slette din bruker, dine
                        boliger etc. Kun tilgangen til innhold fra Boligmappa+.
                      </li>
                    </ul>
                  </div>
                  <DialogFooter>
                    <DialogClose asChild>
                      <Button className="cursor-pointer" variant="secondary">
                        Avbryt
                      </Button>
                    </DialogClose>
                    <DialogClose asChild>
                      <Button
                        variant="destructive"
                        className="cursor-pointer"
                        onClick={() => onCancelConfirm()}
                      >
                        Avslutt abonnement
                      </Button>
                    </DialogClose>
                  </DialogFooter>
                </DialogContent>
              </Dialog>
            )}
            {type === 'userSubscriptionId' && cancelled && (
              <p>Du kan fortsette å bruke Boligmappa+ frem til utløpsdatoen.</p>
            )}
            {type === 'userSinglePaymentId' && (
              <a
                href="https://help.no/kontakt-oss/meld-inn-sak"
                target="_blank"
                rel="noreferrer"
              >
                <Button className="cursor-pointer" variant="secondary">
                  Meld skade
                </Button>
              </a>
            )}
          </div>
        </CardFooter>
      </Card>
    </>
  );
};

export default PurchaseCard;
